import { render, staticRenderFns } from "./Products.vue?vue&type=template&id=e1783b0a&scoped=true&"
import script from "./Products.vue?vue&type=script&lang=js&"
export * from "./Products.vue?vue&type=script&lang=js&"
import style0 from "./Products.vue?vue&type=style&index=0&id=e1783b0a&lang=scss&scoped=true&"
import style1 from "./Products.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1783b0a",
  null
  
)

export default component.exports